import type { HTMLAttributes } from 'react';

export function DetailStack({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={`flex flex-col gap-2 ${className ?? ''}`} {...props} />;
}
